<div class="aca-mig">
  <div class="aca-mig__head">
    <div class="aca-mig__headtext">
      <h2 class="aca-mig__title">{{ 'DMS.MIGRATION.TITLE' | translate }}</h2>
      <p class="aca-mig__subtitle">{{ 'DMS.MIGRATION.SUBTITLE' | translate }}</p>
    </div>

    <!-- the engine's own answer — shown once, so no screen has to guess -->
    <p class="aca-mig__backend" *ngIf="api.available() === false">
      <mat-icon>cloud_off</mat-icon>
      <span>{{ 'DMS.MIGRATION.BACKEND_DOWN' | translate }}</span>
    </p>
  </div>

  <div class="aca-mig__tabs" role="tablist">
    <button
      type="button"
      role="tab"
      class="aca-mig__tab"
      *ngFor="let t of tabs"
      [class.aca-mig__tab--on]="tab() === t.id"
      [attr.aria-selected]="tab() === t.id"
      (click)="select(t.id)"
    >
      {{ t.labelKey | translate }}
    </button>
  </div>

  <app-mig-overview *ngIf="tab() === 'overview'" />
  <app-mig-wizard *ngIf="tab() === 'new'" />
  <app-mig-connections *ngIf="tab() === 'connections'" />
  <app-mig-jobs *ngIf="tab() === 'jobs'" />
  <app-mig-mapping *ngIf="tab() === 'mapping'" />
  <app-mig-validation *ngIf="tab() === 'validation'" />
  <app-mig-history *ngIf="tab() === 'history'" />
  <app-mig-errors *ngIf="tab() === 'errors'" />
  <app-mig-reconciliation *ngIf="tab() === 'reconciliation'" />
  <app-mig-settings *ngIf="tab() === 'settings'" />
</div>
